import React, {Component} from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Button from '../Button'
import CardCaption from '../CardCaption'
import Loader from '../Loader'
import './FormHelp.sass'
import '../../sass/_inputs.sass'
import '../Thanks/Thanks.sass'

/* eslint-disable */
export default class FormHelp extends Component {
  static propTypes = {
    handleClickOverflow: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    current_user: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      formData: {},
      isLoading: false,
      help: false,
      complete: false,
      appeal_id: null,
      textAreaValue: ''
    }
    this.handleClickOverflow = this.props.handleClickOverflow
  }

  onSubmit = event => {
    this.setState({isLoading: true, help: false})
    let textAreaValue = this.state.textAreaValue
    let current_user = this.props.current_user
    const windowLocation = window.location.href
    const userAgent = navigator.userAgent
    const platform = navigator.platform
    const vendor = navigator.vendor
    if (textAreaValue.length > 0) {
      axios.post("/session/support.json", {
        "info": {
          "vendor": vendor,
          "platform": platform,
          "userAgent": userAgent,
          "windowLocation": windowLocation
        },
        "message": textAreaValue,
        "current_user": current_user
      })
        .then((response) => {
          this.setState({isLoading: false, complete: true, appeal_id: response.data.appeal_id, textAreaValue: ''})
        })
        .catch((error) => {
          console.log(error)
          this.setState({isLoading: false})
        })
    }else{
      event.preventDefault()
      this.setState({isLoading: false, help: true})
    }
  }

  handleTextChange = (event) => {
    this.setState({textAreaValue: event.target.value})
  }

  handleUpdate = () => {
    this.handleClickOverflow()
    this.setState({complete: false, help: false})
  }

  handleSecond = (event) => {
    event.preventDefault()
    this.setState({complete: false})
  }

  render() {
    const {isOpen} = this.props
    const {textAreaValue, appeal_id, complete, isLoading, help} = this.state
    return (
      <div>
        {isOpen &&
        <div className="formHelp-wrapper">
          <div className="overlay" onClick={this.handleUpdate} />
          {isLoading ? <Loader/> :
            complete ?
              <form className="formHelp" onSubmit={this.onSubmit}>
                <div className="thanks__caption-wrapper">
                  <div className="thanks__ok" />
                  <h3 className="thanks__caption">Ваш вопрос №{appeal_id} принят для передачи в ведомство</h3>
                </div>
                {/*<p className="formHelp__form-info">Вопрос будут обработан в течение 3 рабочих дней</p>*/}
                <div className="formHelp__btn-wrapper">
                  <Button type="button" bsSize="large" bsStyle="primary" onClick={this.handleSecond}>Новый вопрос</Button>
                  <Button bsSize="large" onClick={this.handleUpdate}>Закрыть</Button>
                </div>
              </form>
              :
              <form className="formHelp" onSubmit={this.onSubmit}>
                <CardCaption bsSize="large" iconId='help_nut'>Заполните форму подачи вопроса</CardCaption>
                <div className="formHelp__form input-wrapper">
                  <textarea
                    className={`formHelp__input ${textAreaValue ? 'label-min' : ''} ${help ? 'error' : ''}`}
                    id="textArea"
                    rows={5}
                    value={textAreaValue}
                    onChange={this.handleTextChange}
                  />
                  <label htmlFor="textArea">Введите ваш вопрос</label>
                </div>
                <div className="formHelp__btn-wrapper">
                  <Button type="submit" bsSize="large" bsStyle="primary">Отправить</Button>
                  <Button bsSize="large" onClick={this.handleUpdate}>Отмена</Button>
                </div>
              </form>
          }
        </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/FormHelp/index.jsx